/* eslint-disable no-undefined */
/* global G, React */
import { useContext, useRef } from 'react'
import { useEventCallback, useEventHandler } from 'platform/react/hook'
import ApplicationContext from 'platform/react/context/application'
import { Toaster, toast } from 'sonner'
import { useTheme } from '@mui/material'

/**
 * Displays `G.DATA` `G.UPDATE` toasts sent through the application's event bus.
 *
 * @return {React.ReactNode}
 */
const SnackBar = () => {
  const theme = useTheme()
  const { eventBus } = useContext(ApplicationContext)
  const _dataReadEventName = useRef(eventBus.type(G.DATA, G.UPDATE))
  const _eventHandler = useEventCallback(({ detail }) => {

    const {
      message,
      duration,
      close,
      action,
      severity,
    } = detail

    const showToast = toast[severity] || toast

    const id = showToast(message, {
      duration,
      closeButton: !!close,
      ...action && {
        label: action.title,
        onClick: () => {
          action.handler({})
          toast.dismiss(id)
        }
      }
    })
  })
  useEventHandler(eventBus, _dataReadEventName.current, _eventHandler)

  return (
    <Toaster
      theme={'dark'}
      position={'top-right'}
      offset={{ top: theme.layout.toolBarHeight }}
      duration={6000}
    />
  )
}

export default SnackBar
